import { Pagination } from "services/search";
import { DataWithPagination } from "services/api/types";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";

import { transformCascoExpiryRow } from "./transformations";
import {
  CascoExpiryRow,
  CascoExpirySearchFormValues,
  CascoExpirySummary,
} from "./types";

/*---------------------------------------------------------------------------------------
  SEARCH — istek kaska (kroz sva vozila)
-----------------------------------------------------------------------------------------*/
export const getCascoExpiriesAPI = async (
  pagination: Pagination,
  values: CascoExpirySearchFormValues
): Promise<DataWithPagination<CascoExpiryRow>> => {
  let path = `/v1/fleet/casco-expiries?`;

  if (values.search) path += `&search=${values.search}`;
  if (values.expirationDateFrom)
    path += `&expirationDateFrom=${values.expirationDateFrom.toISOString()}`;
  if (values.expirationDateTo)
    path += `&expirationDateTo=${values.expirationDateTo.toISOString()}`;
  if (values.status) path += `&status=${values.status}`;
  if (values.vehicleManufacturerId) path += `&vehicleManufacturerId=${values.vehicleManufacturerId}`;
  if (values.vehicleModelId) path += `&vehicleModelId=${values.vehicleModelId}`;
  if (values.vehicleTypeId) path += `&vehicleTypeId=${values.vehicleTypeId}`;

  return await paginatedApiCall(path, pagination, transformCascoExpiryRow);
};

/*---------------------------------------------------------------------------------------
  SUMMARY — brojači po statusu
-----------------------------------------------------------------------------------------*/
export const getCascoExpirySummaryAPI =
  async (): Promise<CascoExpirySummary> => {
    const response = await createApiCall(
      {
        path: `/v1/fleet/casco-expiries/summary`,
        method: "GET",
      },
      {
        getMessage: {
          error: (error: any) => `${transformErrorResponse(error)}`,
        },
      }
    )();

    return {
      expired: response.data?.expired ?? 0,
      expiring: response.data?.expiring ?? 0,
      valid: response.data?.valid ?? 0,
      total: response.data?.total ?? 0,
    };
  };
